import React, { useState, useEffect } from 'react';

const AnimateSettings = ({ isOpen, onClose, onSave, mPathSelection, mObjectSelection, rectData, onOffsetObj, onOffsetPath, onResizeView }) => {

  const [selectedPath, setSelectedPath] = useState('');
  const [selectedObject, setSelectedObject] = useState('');

  const [duration, setDuration] = useState(5);
  const [rotateMode, setRotateMode] = useState("auto");

  const [pathInvisible, setPathInvisible] = useState(true);
  const [ease, setEase] = useState(true);

  const [keyTimes, setKeyTimes] = useState("0;1");

  const [startRotation, setStartRotation] = useState(0);
  const [endRotation, setEndRotation] = useState(0);

  const [startOpacity, setStartOpacity] = useState(1);
  const [endOpacity, setEndOpacity] = useState(1);

  const [startScale, setStartScale] = useState(1);
  const [endScale, setEndScale] = useState(1);

  const [offset, setOffset] = useState(0);
  const [pad, setPad] = useState(0);

  const [isRepeating, setIsRepeating] = useState(true);
  const [repeatThreshold, setRepeatThreshold] = useState(1);

  const [startOffset, setStartOffset] = useState(0);
  const [endOffset, setEndOffset] = useState(100);



  useEffect(() => {
    if (rectData)
    {
  
      if(rectData?.mPath)
      {        
          setSelectedPath("A path is selected");
      }
      else
      {
        setSelectedPath("Path not selected");
      }

      if(rectData?.mObj)
      {
        setSelectedObject("An object is selected");
      }
      else
      {
        setSelectedObject("An object not selected");
      }
      if(rectData?.animationSettings?.pathInvisible)
      {
        setPathInvisible(rectData.animationSettings.pathInvisible);
      }
      if(rectData?.animationSettings?.ease)
      {
        setEase(rectData.animationSettings.ease);
      }    
      if(rectData?.animationSettings?.duration)
      {
        setDuration(rectData.animationSettings.duration);
      }
      if(rectData?.animationSettings?.rotateMode)
      {
        setRotateMode(rectData.animationSettings.rotateMode);
      }
      if(rectData?.animationSettings?.startRotation)
      {
        setStartRotation(rectData.animationSettings.startRotation);
      }
      if(rectData?.animationSettings?.endRotation)
      {
        setEndRotation(rectData.animationSettings.endRotation);
      }
      if(rectData?.animationSettings?.startOpacity)
      {
        setStartOpacity(rectData.animationSettings.startOpacity);
      }
      if(rectData?.animationSettings?.endOpacity)
      {
        setEndOpacity(rectData.animationSettings.endOpacity);
      }
      if(rectData?.animationSettings?.startScale)
      {
        setStartScale(rectData.animationSettings.startScale);
      }
      if(rectData?.animationSettings?.endScale)
      {
        setEndScale(rectData.animationSettings.endScale);
      }
      if(rectData?.animationSettings?.isRepeating)
      {
        setIsRepeating(rectData.animationSettings.isRepeating);
      }
      if(rectData?.animationSettings?.repeatThreshold)
      {
        setRepeatThreshold(rectData.animationSettings.repeatThreshold);
      }    
      if (rectData?.animationSettings?.startOffset !== undefined)
      {
        setStartOffset(rectData.animationSettings.startOffset);
      }
      if (rectData?.animationSettings?.endOffset !== undefined)
      {
        setEndOffset(rectData.animationSettings.endOffset);
      }

    }
  },[rectData, isOpen])

  const handleSave = () => {


    onSave({
      selectedPath,
      selectedObject,
      duration,
      rotateMode,
      pathInvisible,
      ease,
      keyTimes,
      startRotation,
      endRotation,
      startOpacity,
      endOpacity,
      startScale,
      endScale,
      offset,
      pad,
      isRepeating,
      repeatThreshold,
        // 👇 ADD THESE
      startOffset,
      endOffset
    });

    onClose();
  };

  const handlePathSelect = () => {
    mPathSelection();
  };


  const handleOffsetObj = () =>
  {
    onOffsetObj();
  }

  const handleOffsetPath = () =>
  {
    onOffsetPath();
  }

  const handleResizeView = () =>
  {
    onResizeView();
  }
  const handleObjectSelect = () => {
    mObjectSelection();
  };

  if (!isOpen) return null;


  const clampOffset = (val) => Math.max(0, Math.min(100, val));
  

  return (

    <div style={styles.overlay}>
      <div style={styles.dialog}>

        <h2>Animate Settings</h2>

        {/* TOOL BUTTONS */}

        <div style={styles.buttonRow}>
          <button onClick = {handleOffsetObj} style={styles.smallButton}>Offset Object</button>
          <button onClick = {handleOffsetPath} style={styles.smallButton}>Offset View</button>
          <button onClick = {handleResizeView} style={styles.smallButton}>Resize View</button>
        </div>


        {/* PATH SELECTION */}

        <div style={styles.selectionRow}>
          <button onClick={handlePathSelect} style={styles.button}>Select Path</button>
          <div style={styles.displayBox}>
            {selectedPath || "No path selected"}
          </div>
        </div>


        {/* OBJECT SELECTION */}

        <div style={styles.selectionRow}>
          <button onClick={handleObjectSelect} style={styles.button}>Select Object</button>
          <div style={styles.displayBox}>
            {selectedObject || "No object selected"}
          </div>
        </div>


        {/* DURATION */}

        <div style={styles.row}>
          <label>Duration (seconds)</label>
          <input
            type="number"
            value={duration}
            min="0.1"
            step="0.1"
            onChange={(e) => setDuration(e.target.value)}
          />
        </div>


        {/* ROTATE MODE */}

        <div style={styles.row}>
          <label>Rotate Mode</label>
          <select
            value={rotateMode}
            onChange={(e) => setRotateMode(e.target.value)}
          >
            <option value="auto">auto</option>
            <option value="auto-reverse">auto-reverse</option>
            <option value="0">none</option>
          </select>
        </div>




        {/* INVISIBLE PATH */}

        <div style={styles.row}>
          <label>
            <input
              type="checkbox"
              checked={pathInvisible}
              onChange={() => setPathInvisible(!pathInvisible)}
            />
            Invisible Path
          </label>
        </div>

        <div style={styles.row}>
          <label>
            <input
              type="checkbox"
              checked={ease}
              onChange={() => setEase(!ease)}
            />
            Smooth Motion
          </label>
        </div>



        {/* ROTATION */}

        <div style={styles.rangeRow}>
          <label style={styles.label}>Rotation</label>
          <input
            style={styles.input}
            type="number"
            value={startRotation}
            onChange={(e) => setStartRotation(e.target.value)}
          />
          <span>→</span>
          <input
            style={styles.input}
            type="number"
            value={endRotation}
            onChange={(e) => setEndRotation(e.target.value)}
          />
        </div>


        {/* OPACITY */}

        <div style={styles.rangeRow}>
          <label style={styles.label}>Opacity</label>
          <input
            style={styles.input}
            type="number"
            step="0.1"
            value={startOpacity}
            onChange={(e) => setStartOpacity(e.target.value)}
          />
          <span>→</span>
          <input
            style={styles.input}
            type="number"
            step="0.1"
            value={endOpacity}
            onChange={(e) => setEndOpacity(e.target.value)}
          />
        </div>


        {/* SCALE */}

        <div style={styles.rangeRow}>
          <label style={styles.label}>Scale</label>
          <input
            style={styles.input}
            type="number"
            step="0.1"
            value={startScale}
            onChange={(e) => setStartScale(e.target.value)}
          />
          <span>→</span>
          <input
            style={styles.input}
            type="number"
            step="0.1"
            value={endScale}
            onChange={(e) => setEndScale(e.target.value)}
          />
        </div>

        {/* PATH OFFSET */}
            <div style={styles.rangeRow}>
              <label style={styles.label}>Path Offset (%)</label>
              <input
                style={styles.input}
                type="number"
                min="0"
                max="100"
                value={startOffset}
                onChange={(e) => setStartOffset(clampOffset(Number(e.target.value)))}
              />
              <span>→</span>
              <input
                style={styles.input}
                type="number"
                min="0"
                max="100"
                value={endOffset}
                onChange={(e) => setEndOffset(clampOffset(Number(e.target.value)))}
              />
            </div>


        {/* REPEAT */}

        <div style={styles.row}>
          <label>
            <input
              type="checkbox"
              checked={isRepeating}
              onChange={() => setIsRepeating(!isRepeating)}
            />
            Always Repeating
          </label>
        </div>

        {!isRepeating &&
          <div style={styles.row}>
            <label>Repeat Count</label>
            <input
              type="number"
              value={repeatThreshold}
              min="1"
              onChange={(e) => setRepeatThreshold(e.target.value)}
            />
          </div>
        }


        {/* ACTION BUTTONS */}

        <div style={styles.actions}>
          <button onClick={handleSave}>Save</button>          
          <button onClick={onClose}>Cancel</button>
        </div>

      </div>
    </div>
  );
};


/* STYLES */

const styles = {

  label: {
    width: '120px'
  },

  input: {
    width: '70px',
    padding: '4px',
    boxSizing: 'border-box'
  },

  overlay:{
    position:'fixed',
    top:0,
    left:0,
    width:'100%',
    height:'100%',
    backgroundColor:'rgba(0,0,0,0.5)',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },

  dialog:{
    backgroundColor:'white',
    padding:'20px',
    borderRadius:'8px',
    width:'650px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.2)'
  },

  buttonRow:{
    display:'flex',
    gap:'10px',
    marginBottom:'10px'
  },

  smallButton:{
    flex:1,
    padding:'6px'
  },

  selectionRow:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    marginBottom:'10px'
  },

  button:{
    padding:'8px 12px',
    backgroundColor:'#4CAF50',
    color:'white',
    border:'none',
    borderRadius:'4px',
    cursor:'pointer',
    width:'130px'
  },

  displayBox:{
    backgroundColor:'#f1f1f1',
    padding:'8px',
    width:'250px',
    borderRadius:'4px',
    fontSize:'12px',
    overflow:'hidden',
    textOverflow:'ellipsis',
    whiteSpace:'nowrap'
  },

  row:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    marginBottom:'8px'
  },

  rangeRow:{
    display:'flex',
    alignItems:'center',
    gap:'6px',
    marginBottom:'8px'
  },

  actions:{
    display:'flex',
    justifyContent:'space-between',
    marginTop:'20px'
  }

};

export default AnimateSettings;


